import { Link } from "react-router-dom";

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  icon?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeader({
  title,
  subtitle,
  icon = "ri-bookmark-3-line",
  moreTo,
  moreLabel = "查看全部",
}: SectionHeaderProps) {
  return (
    <div className="mb-5 flex items-end justify-between gap-4">
      <div>
        <h2 className="flex items-center gap-2 font-heading text-xl font-extrabold text-foreground-950 md:text-2xl">
          <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary-100 text-primary-600">
            <i className={`${icon} text-lg`}></i>
          </span>
          {title}
        </h2>
        {subtitle && <p className="mt-1.5 text-sm text-foreground-500">{subtitle}</p>}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="flex shrink-0 items-center gap-1 whitespace-nowrap rounded-md px-2 py-1 text-sm font-medium text-primary-600 transition-colors hover:bg-primary-50 cursor-pointer"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      )}
    </div>
  );
}